import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import { toast } from "@/lib/use-toast";
import type { MeasurementField, MeasurementFieldCreate } from "@/types/measurement";
import { measurementGroupQueryKeys } from "./measurement-groups";
import { archiveMeasurementField, createMeasurementField, listMeasurementFields, updateMeasurementField } from "@/api/provider/settings/measurement-field";
import { invalidateByKey } from "@/api/utils/query-helpers";
export const measurementFieldQueryKeys = {
  all: ["settings", "measurement-fields"] as const,
  list: () => [...measurementFieldQueryKeys.all, "list"] as const
};
export const measurementFieldQueryOptions = {
  list: () => ({
    queryKey: measurementFieldQueryKeys.list(),
    queryFn: () => listMeasurementFields(),
    select: (data: MeasurementField[] | null) => data ?? []
  })
};
export const useCreateFieldMutation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp,
      onError: _temp2,
      onSettled: _temp3
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export const useUpdateFieldMutation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp4,
      onError: _temp5,
      onSettled: _temp6
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export const useArchiveFieldMutation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp7,
      onError: _temp8,
      onSettled: _temp9
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
function _temp(data) {
  return createMeasurementField(data);
}
function _temp2(error) {
  toast({
    title: "Error",
    description: error.message || "Failed to create field",
    variant: "error"
  });
}
function _temp3() {
  invalidateByKey(measurementFieldQueryKeys.list());
}
function _temp4(t0) {
  const {
    fieldId,
    data
  } = t0;
  return updateMeasurementField(fieldId, data);
}
function _temp5() {
  toast({
    title: "Error",
    description: "Failed to update field",
    variant: "error"
  });
}
function _temp6() {
  invalidateByKey(measurementFieldQueryKeys.list());
  invalidateByKey(measurementGroupQueryKeys.list());
}
function _temp7(fieldId) {
  return archiveMeasurementField(fieldId);
}
function _temp8() {
  toast({
    title: "Error",
    description: "Failed to delete field",
    variant: "error"
  });
}
function _temp9() {
  invalidateByKey(measurementFieldQueryKeys.list());
  invalidateByKey(measurementGroupQueryKeys.list());
}